export default __webpack_public_path__ + "static/media/shuffle.10e3d7ee.png";